'use client'

import { Destination as DestinationsV2 } from '@feat/feat-destinations-v2/page'
import type { ReactNode } from 'react'

type DestinationV2ClientProps = {
  children?: ReactNode
  data: Parameters<typeof DestinationsV2>[0]['data']
}

export function DestinationV2Client({ children, data }: DestinationV2ClientProps) {
  return <DestinationsV2 data={data}>{children}</DestinationsV2>
}
